import DialerPanel from './DialerPanel';

export * from './DialerPanel';
export { DialerPanel };
export default DialerPanel;
